@if (
    userDataService?.userData?.configParams?.isBrazilBankRegEnabled &&
    ['2020', '2021', '854', '3'].includes(failureResponse?.errorResponse?.errorCode)
) {
    <div [ngClass]="isMobile ? 'mx-3' : 'mx-auto max-width-500'" class="deposit-failure-wrapper text-center py-2">
        <div>
            <img [src]="assetsData.assets.miscimages?.depositFailure" />
            <h4 class="my-2">{{ 'PARTY.CASHIER.web.deposit.failure.header' | translate }}</h4>
            <p class="font-weight-bold">
                {{
                    (userDataService?.userData?.configParams?.pixBrInfo?.isSeamless
                        ? 'PARTY.CASHIER.web.deposit.failure.descriptionNew'
                        : 'PARTY.CASHIER.web.deposit.failure.description'
                    ) | translate
                }}
            </p>
            <p>
                {{ 'PARTY.CASHIER.web.deposit.bankregistration.failure.content1' | translate }}
            </p>
            <p>
                {{ 'PARTY.CASHIER.web.deposit.bankregistration.failure.content2' | translate }}
            </p>
        </div>
        <div>
            <button class="btn btn-primary w-100 mb-3" (click)="redirectToMainCashier()">
                {{ btnData?.content | translate }}
            </button>
            <button class="btn btn-light w-100" (click)="goBackToDeposit()">
                {{ 'PARTY.CASHIER.web.deposit.bankregistration.goback.button' | translate }}
            </button>
        </div>
    </div>
}
